var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55707 0.597683C10.354 -0.199229 11.646 -0.199227 12.4429 0.597684L21.4023 9.55707C22.1992 10.354 22.1992 11.646 21.4023 12.4429L12.4429 21.4023C11.646 22.1992 10.354 22.1992 9.55707 21.4023L0.597683 12.4429C-0.199229 11.646 -0.199227 10.354 0.597684 9.55707L9.55707 0.597683ZM11.481 1.55964C11.2153 1.294 10.7847 1.294 10.519 1.55964L1.55964 10.519C1.294 10.7847 1.294 11.2153 1.55964 11.481L10.519 20.4404C10.7847 20.706 11.2153 20.706 11.481 20.4404L20.4404 11.481C20.706 11.2153 20.706 10.7847 20.4404 10.519L11.481 1.55964Z",
    fill: "#A90000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62712 15.125C9.62712 14.3656 10.2427 13.75 11.0021 13.75C11.7615 13.75 12.3771 14.3656 12.3771 15.125C12.3771 15.8844 11.7615 16.5 11.0021 16.5C10.2427 16.5 9.62712 15.8844 9.62712 15.125Z",
    fill: "#A90000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76182 6.86818C9.68856 6.13564 10.2638 5.5 11 5.5C11.7362 5.5 12.3114 6.13564 12.2382 6.86818L11.7559 11.6909C11.7171 12.0793 11.3903 12.375 11 12.375C10.6097 12.375 10.2829 12.0793 10.2441 11.6909L9.76182 6.86818Z",
    fill: "#A90000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.f97f7a954ccf8030d5cf89446f3e71ae.svg";
export { ForwardRef as ReactComponent };